import { render, staticRenderFns } from "./ColorRow.vue?vue&type=template&id=4d8d6b94&"
import script from "./ColorRow.vue?vue&type=script&lang=js&"
export * from "./ColorRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ColorRow.vue"
export default component.exports